/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

/*
    TEMPORARY COMPONENT:
    This table shows the properties that are filtered out
    of the API response because of CMS data issues that will
    break the search and filter functionality.
*/

const BadProperties = ({ allProperties, filteredProperties }) => {
    // Find the properties that are filtered out of the API response
    const badProperties = allProperties.filter(property => filteredProperties.findIndex(p => p._id === property._id) === -1);

    return (
        <table className="table is-striped is-narrow" style={{ margin: '4rem' }}>
            <thead>
                <tr style={{ fontSize: '24px' }}>
                    <th colSpan={5}>These properties can not be searched or filtered:</th>
                </tr>
                <tr>
                    <th></th>
                    <th>id</th>
                    <th>name</th>
                    <th>office park id</th>
                    <th>data issues</th>
                </tr>
            </thead>
            <tfoot>
                <tr style={{ fontSize: '18px' }}>
                    <td colSpan={5}><strong>Total Visible Properties: {allProperties.length} | Valid Properties: {filteredProperties.length} | Properties with errors: {badProperties.length}</strong></td>
                </tr>
            </tfoot>
            <tbody>
                {badProperties.map((property, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{property._id}</td>
                        <td>{property.name}</td>
                        <td>{property.office_park && property.office_park.id}</td>
                        <td>
                            <span>{(property.order && property.order > 0) ? '' : 'order is invalid. '}</span>
                            <span>{property.slug ? '' : 'slug is invalid. '}</span>
                            <span>{property.city ? '' : 'city is invalid. '}</span>
                            <span>{property.state ? '' : 'state is invalid. '}</span>
                            <span>{property.street_address ? '' : 'street_address is invalid. '}</span>
                            <span>{property.region ? '' : 'region is invalid. '}</span>
                            <span>{(property.geo && property.geo[0] && property.geo[1]) ? '' : 'geo is invalid. '}</span>
                            <span>{property.submarket ? '' : 'submarket is invalid. '}</span>
                            <span>{property.rba === undefined ? 'rba is missing. ' : ''}</span>
                            <span>{property.in_service === undefined ? 'in_service is missing. ' : ''}</span>
                            <span>{property.development === undefined ? 'development is missing. ' : ''}</span>
                            <span>{property.redevelopment === undefined ? 'redevelopment is missing. ' : ''}</span>
                            <span>{!(!property.in_service && !property.development && !property.redevelopment && !property.repositioning) ? '' : 'property type cannot be determined. '}</span>
                            <span>{property.web_photos === undefined ? 'web_photos is missing. ' : ''}</span>
                            <span>{property.thumbnail === undefined ? 'thumbnail is missing. ' : ''}</span>
                            <span>{property.spaces ? '' : 'spaces is invalid. '}</span>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

BadProperties.propTypes = {
    allProperties: PropTypes.array,
    filteredProperties: PropTypes.array,
};

export default connect(
    state => ({
        allProperties: state.content.properties,
        /* THIS IS THE SAME FILTER USED IN Office.js */
        filteredProperties: state.content.properties
            // temporarily filter the properties
            // these fields can not be missing or else the search/filter breaks
            // currently, the api is sending office park properties that do not have these fields populated
            ? state.content.properties.filter(p => {
                return (p.order && p.order > 0)
                    && p.name
                    && p.city
                    && p.state
                    // QUESTION: filter for street_address?
                    && p.web_photos !== undefined
                    && p.thumbnail !== undefined
                    && p.slug
                    && p.rba !== undefined
                    && p.region
                    && (p.geo && p.geo[0] && p.geo[1])
                    && p.submarket
                    && p.in_service !== undefined
                    && p.development !== undefined
                    && p.redevelopment !== undefined
                    && !(!p.in_service && !p.development && !p.redevelopment && !p.repositioning)
                    && p.spaces;
            })
            // change after api fixed
            // ? state.content.properties
            : null,
    }),
    null,
)(BadProperties);
